/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ButtonCtaItem = (props) => {
    const { link, linkProperties = {} } = props;
    
    const colour = linkProperties?.colour ?? "brand";
    const icon = linkProperties?.icon ?? "none";
    const style = linkProperties?.style ?? "primary";

    const [classes, setClasses] = useState("btn icon");
    const [target, setTarget] = useState(undefined);

    useEffect(() => {
        if (link?.is_external || link?.new_tab) {
            setTarget("_blank");
        }
        let class_list = ["btn icon"];
        class_list.push(colour);
        class_list.push(style);
        const finalClasses = class_list.join(" ");
        setClasses(finalClasses);
    }, [link, colour, style]);

    return (
        <div className='simplicity-linkbutton'>
            {link && link?.url && link?.text && (
                <a 
                    className={classes}
                    href={link?.url}
                    target={target}
                >
                    <div>{link?.text}</div>
                    {icon === "external" &&
                        <FontAwesomeIcon icon={`fa-regular fa-arrow-up-right-from-square`} />
                    }
                    {icon === "arrow" &&
                        <FontAwesomeIcon icon={`fa-regular fa-arrow-right`} />
                    }
                </a>
            )}
        </div>
    );
};

ButtonCtaItem.displayName = "ButtonCtaItem";
export { ButtonCtaItem };
